import { useCallback, useEffect, useRef, useState } from "react";

export function useScrollToFirstInvalid() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (attempt === 0) return;
    const container = containerRef.current;
    if (!container) return;
    const el = container.querySelector<HTMLElement>('[aria-invalid="true"]');
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      // Defer focus so it doesn't interrupt the smooth-scroll animation
      setTimeout(() => el.focus({ preventScroll: true }), 300);
    } else {
      // Scroll the top of the container into view (relative to whichever ancestor scrolls)
      container.firstElementChild?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [attempt]);

  const trigger = useCallback(() => setAttempt((n) => n + 1), []);
  const reset = useCallback(() => setAttempt(0), []);

  return {
    containerRef,
    showErrors: attempt > 0,
    trigger,
    reset,
  };
}
